import { render, staticRenderFns } from "./Showcase.vue?vue&type=template&id=008ec251&"
import script from "./Showcase.vue?vue&type=script&lang=js&"
export * from "./Showcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports